var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5861 16H0.413812C0.185297 16 0 15.8114 0 15.5789V0.421067C0 0.188545 0.185297 0 0.413812 0H23.5862C23.8147 0 24 0.188545 24 0.421067V15.5789C24 15.8114 23.8147 16 23.5861 16Z",
    fill: "#012169"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 0.421067C23.9999 0.188545 23.8146 0 23.5861 0H21.7348L14.0688 5.11058V0H9.93096V5.11058L2.26509 0H0.413811C0.185296 0 0 0.188545 0 0.421067V1.51004L6.57696 5.89469H0V10.1052H6.57696L0 14.4899V15.5789C0 15.8114 0.185296 16 0.413811 16H2.26513L9.93106 10.8893V16H14.0689V10.8893L21.7349 16H23.5862C23.8147 16 24 15.8114 24 15.5789V14.4899L17.423 10.1053H23.9999V5.89474H17.4229L23.9999 1.51004V0.421067Z",
    fill: "#F5F5F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 6.73682H13.2413V0H10.7586V6.73682H0V9.26312H10.7586V16H13.2413V9.26312H23.9999V6.73682Z",
    fill: "#C8102E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38815 10.1052L0.0117188 15.6379C0.0410155 15.8413 0.205781 16 0.413764 16H0.983714L9.90822 10.1053L8.38815 10.1052Z",
    fill: "#C8102E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2368 10.1052H14.7168L23.6283 15.9912C23.836 15.9687 23.9999 15.7961 23.9999 15.5789V15.2327L16.2368 10.1052Z",
    fill: "#C8102E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.886065L7.58338 5.89491H9.10344L0.241077 0.0412598C0.099515 0.108183 0 0.251988 0 0.421265V0.886065Z",
    fill: "#C8102E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5904 5.89467L23.9869 0.34862C23.9521 0.152011 23.7908 0 23.5875 0H22.9947L14.0703 5.89467H15.5904Z",
    fill: "#C8102E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUk);
export default __webpack_public_path__ + "static/media/UK.a2db087bc96a5721c15c39bf4f315b64.svg";
export { ForwardRef as ReactComponent };